/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue';
import VxCard from './components/vx-card/VxCard.vue';
import VxList from './components/vx-list/VxList.vue';
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue';
import FeatherIcon from './components/FeatherIcon.vue';
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue';

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);

// v-select component
import vSelect from 'vue-select';
import { SELECT_LEGENDS } from './utils/constants';

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'XIcon',
          svgClasses: 'w-4 h-4',
        },
      }),
  },
  OpenIndicator: {
    render: (createElement) =>
      createElement('feather-icon', {
        props: {
          icon: 'ChevronDownIcon',
          svgClasses: 'w-5 h-5',
        },
      }),
  },
});

const baseVSelectRender = vSelect.render;
vSelect.render = function (createElement) {
  const hasCustomNoOptions =
    (this.$slots && this.$slots['no-options']) ||
    (this.$scopedSlots && this.$scopedSlots['no-options']);

  if (!hasCustomNoOptions) {
    this.$scopedSlots = Object.assign({}, this.$scopedSlots, {
      'no-options': (scope) => [
        this._v(
          scope && scope.loading
            ? SELECT_LEGENDS.LOADING
            : SELECT_LEGENDS.NO_OPTIONS,
        ),
      ],
    });
  }

  return baseVSelectRender.call(this, createElement);
};

Vue.component(vSelect);
